import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { SessionsPage } from './pages/SessionsPage';
import { SimulatorPage } from './pages/SimulatorPage';
import { DiaperSandboxPage } from './pages/DiaperSandboxPage';
import { DiaperInspectorPage } from './pages/DiaperInspectorPage';
import { DiaperSearchPage } from './pages/DiaperSearchPage';
import { ClipLifetimePage } from './pages/ClipLifetimePage';
import { EventLogPage } from './pages/EventLogPage';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ToastContainer } from './components/Toast';
import { useAuthStore } from './stores/authStore';
import { useEnvironmentStore } from './stores/environmentStore';

function App() {
  const initialize = useAuthStore((s) => s.initialize);
  const loadEnvironment = useEnvironmentStore((s) => s.load);

  useEffect(() => {
    initialize();
    loadEnvironment();
  }, [initialize, loadEnvironment]);
  // Diaper models are loaded per-page once a Nova account is selected.
  // The catalog is account-scoped at the proxy layer so we cannot fetch it
  // until the user has chosen which account to drive (via URL param or picker).

  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedRoute><Layout><SessionsPage /></Layout></ProtectedRoute>} />
        <Route path="/sessions" element={<ProtectedRoute><Layout><SessionsPage /></Layout></ProtectedRoute>} />
        <Route path="/simulator" element={<ProtectedRoute><Layout><SimulatorPage /></Layout></ProtectedRoute>} />
        <Route path="/eventlog" element={<ProtectedRoute><Layout><EventLogPage /></Layout></ProtectedRoute>} />
        <Route path="/clip-lifetime" element={<ProtectedRoute><Layout fullWidth><ClipLifetimePage /></Layout></ProtectedRoute>} />
        <Route path="/diaper-search" element={<ProtectedRoute><Layout fullWidth><DiaperSearchPage /></Layout></ProtectedRoute>} />
        <Route path="/diaper-inspector" element={<ProtectedRoute><Layout fullWidth><DiaperInspectorPage /></Layout></ProtectedRoute>} />
        <Route path="/diaper-models" element={<ProtectedRoute><Layout fullWidth><DiaperSandboxPage /></Layout></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
